import { createContext } from "react"

import type { PolygonPickerConfig } from "./typings"

export type PolygonPickerConfigType = (func: (close: () => void) => PolygonPickerConfig) => void

export const PolygonPickerContext = createContext<PolygonPickerConfigType>(() => {
	throw new Error("No PolygonPickerProvider found")
})
